import { Check } from "lucide-react";
import type { JSX } from "react";
import { toast, Toaster as SonnerToaster } from "sonner";

import { t } from "@/i18n";

export { toast };

/**
 * A done thing that can be taken back: the message and "Bekor qilish", for as long as the toast
 * is up. The caller's `onUndo` reverses what was done.
 */
export function toastUndo(message: string, onUndo: () => void): void {
  toast(message, { action: { label: t("ui.undo"), onClick: onUndo }, duration: 4200 });
}

/**
 * Mount once, near the root. Dark, bottom right, one line; on a phone above the tab bar. Reduced
 * motion is honoured by the global stylesheet.
 */
export function Toaster(): JSX.Element {
  return (
    <SonnerToaster
      position="bottom-right"
      closeButton={false}
      duration={2600}
      offset={24}
      mobileOffset={{ bottom: "calc(76px + env(safe-area-inset-bottom))" }}
      icons={{ success: <Check className="size-4 text-toast-ok" strokeWidth={1.5} aria-hidden="true" /> }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "flex w-full items-center gap-2.5 rounded-control bg-toast px-4 py-2.5 text-sm text-toast-ink shadow-overlay",
          title: "min-w-0 flex-1",
          actionButton: "h-7 shrink-0 cursor-pointer rounded-small bg-toast-action px-2.5 text-sm font-medium text-toast-ink",
          closeButton: "text-toast-ink",
        },
      }}
    />
  );
}
